import React, { useEffect, useState } from "react";
import Header from "../../components/ui/Header";

const API_URL = import.meta.env.VITE_API_URL;

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export default function ProfilePage() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadProfile = async () => {
      setLoading(true);
      setError("");

      try {
        const userId = sessionStorage.getItem("user_id");
        const res = await fetch(`${API_URL}/profile`, {
          method: "GET",
          credentials: "include",
          headers: userId ? { "X-User-ID": userId } : {},
        });

        const data = await res.json();
        if (!res.ok) {
          throw new Error(data?.error || "خطا در دریافت پروفایل");
        }

        setProfile(data.profile || null);
        if (data.profile) {
          sessionStorage.setItem("user_profile", JSON.stringify(data.profile));
        }
      } catch (err) {
        const cachedProfile = sessionStorage.getItem("user_profile");
        if (cachedProfile) {
          try {
            setProfile(JSON.parse(cachedProfile));
            return;
          } catch (_) {}
        }
        setError(err.message || "خطای شبکه");
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <div className="min-h-screen bg-bg-primary text-text-primary">
      <main className="max-w-3xl mx-auto px-4 pt-24 pb-10">
        <div className="rounded-2xl border border-border bg-surface p-6 shadow-sm">
          <h1 className="text-2xl font-bold mb-2">پروفایل کاربر</h1>
          <p className="text-text-secondary mb-6">اطلاعات حساب شما بعد از ورود</p>

          {loading && <p>در حال بارگذاری...</p>}

          {!loading && error && (
            <p className="text-red-500">{error}</p>
          )}

          {!loading && !error && profile && (
            <div className="space-y-4">
              <ProfileRow label="شناسه کاربر" value={profile.id} />
              <ProfileRow label="نام" value={profile.name} />
              <ProfileRow label="ایمیل" value={profile.email} />
              <ProfileRow label="تاریخ عضویت" value={formatDate(profile.created_at)} />
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

function ProfileRow({ label, value }) {
  return (
    <div className="flex items-center justify-between rounded-xl border border-border bg-bg-secondary px-4 py-3">
      <span className="text-text-secondary">{label}</span>
      <span className="font-medium">{value || "-"}</span>
    </div>
  );
}
